import React, { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'

import { t } from '@/i18n'
import { IDeal } from '@/types'
import { AppLayout, FormWrapper, LanguageSelector, Modal } from '@/components'
import Form from './form'
import History from './history'
import { useData } from './useData'
import Treatments from '@/pages/Deal/treatments'

const EditDeal: React.FC = () => {
  const { id = '' } = useParams()
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [showHistory, setShowHistory] = useState<boolean>(false)
  const [showTreatments, setShowTreatments] = useState<boolean>(false)
  const { data, loading, submitting, onSubmit } = useData({ id })

  const onSubmitForm = useCallback(
    (d: IDeal) => {
      onSubmit(`deals/deals/${id}/`, true, () => {
        window.location.reload()
      })(d)
    },
    [id, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <FormWrapper
        breadcrumbs={[{ name: isEditing ? 'edit_deal' : 'view_deal' }]}
        loading={loading}
        isEditing={isEditing}
        onEdit={() => setIsEditing(true)}
        extraButtons={[
          {
            text: t('history'),
            className: 'success deal-history-button',
            onClick: () => setShowHistory(true),
          },
          {
            text: t('treatments'),
            className: 'success deal-history-button',
            onClick: () => setShowTreatments(true),
          },
        ]}
      >
        <div className="content-box">
          <div className="scroll-wrap">
            <div className="content-title">
              <h2>
                {isEditing
                  ? t('edit_deal_label', { label: data.id })
                  : t('view_deal')}
              </h2>
            </div>
            <Form
              key={data.updateTime}
              isEditing={isEditing}
              initialData={data}
              loading={loading}
              submitting={submitting}
              onCancel={() => setIsEditing(false)}
              onSubmit={onSubmitForm}
            />
          </div>
        </div>
      </FormWrapper>
      <Modal
        className="deal-history"
        visible={showHistory}
        title={t('updates_history')}
        onClose={() => setShowHistory(false)}
      >
        <History id={id} />
      </Modal>
      <Modal
        className="deal-history"
        visible={showTreatments}
        title={t('treatments_list')}
        onClose={() => setShowTreatments(false)}
      >
        <Treatments id={id} />
      </Modal>
    </AppLayout>
  )
}

export default EditDeal
